const scrapingTagEditorFormRules = {
  tagGroupIds: [
    {
      required: true,
      message: 'Please provide at least one tag group',
    },
  ],
}

export default scrapingTagEditorFormRules
